<!-- 查询选手的成绩 -->
<template>
<div>
    <div class="page-form" v-if="isShow">
        <PageBack :title="title" />
        <el-button class="mg-t-20" @click="handleExport" type="success" size="medium">导出成绩</el-button>
        <div class="custom-table custom-table2">
            <div class="size20 center mg-b-10 bold">{{ pubTitle }}</div>
            <el-table :data="tableData" :row-class-name="tableRowClassName" 
                style="width: 100%" border>
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
    components:{
        PageBack
    },
    data(){
        return{
            isShow: false,
            tableData:[],
            tableHeaders: [
                {label: '名次', prop: 'rank'},
                {label: '选手', prop: 'username'},
                {label: '搭档', prop: 'partnerName'},
                {label: '积分', prop: 'score'},
                {label: '胜轮次', prop: 'winNum'},
                {label: '级差总分', prop: 'totalRank'},
                {label: '升级数', prop: 'number'},
                {label: '对手总分', prop: 'totalPlayers'},
                {label: '对手总级差分', prop: 'totalMinusPlayers'},                
                {label: '搭档总分', prop: 'partnerScore'},
                {label: '搭档总级差分', prop: 'partnerRank'},
            ],
            dynamicHeaders:[],
            pubTitle: '',
            exportData: [],
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        publishId(){
            return this.$route.query.id
        } 
    },
    created(){
        
    },
    mounted() {
        if(this.publishId){
            this.getQuery()
            // this.getTableHeaders()
        }
        this.initData()
    },
    methods: {
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        getTableHeaders(){
            let params = {
                opcode: this.$code.TableHeaderCode,
                i_serial_mark:this.publishId,

            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                         
                    // console.log(result[0])   
                    let arr =  Object.keys(result[0])    
                    // console.log(arr)  
                    let newData = []   
                    for (let key of arr) {                       
                        let newArr = key.split('-')                     
                        newData.push({
                            label: newArr[0],
                            id: newArr[1]
                        }); 
                    }
                    // console.log(newData)
                    let outputArry = this.transformObjectToArray(newData)
                    // console.log(outputArry)
                }
            })
        },
        getQuery(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    this.pubTitle = result['主题']
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: this.publishId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){

                        this.tableData = result.map(item=>{                    
                            return{
                                username: item['选手'],
                                rank: item['名次'],
                                score: item['积分'],
                                winNum: item['胜轮次'],    
                                number: item['升级数'],                           
                                totalRank: item['级差总分'],
                                totalPlayers: item['对手总分'],
                                totalMinusPlayers: item['对手总级差分'],
                                partnerScore: item['搭档总分'],
                                partnerRank: item['搭档总级差分'],
                                partnerName: item['搭档'],
                                totalScore: item['累计分'],
                            }
                        })  
                    // 导出数据过滤掉了选手编号，使用map创建一个新数组，排除'选手编号'字段（不修改原数组）
                    this.exportData = result.map(item=>{
                        const { 选手编号, ...rest } = item;
                        return rest
                    })
                    // 导出的数据，返回一个表头
                    let outputArry = this.$help.transformObjectToArray(result[0])
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let arr= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));

                    this.dynamicHeaders = outputArry.filter(i=>arr.includes(i.prop))

                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        transformToArray(obj){
            const result = []     
            for (const key of obj) {
                if(obj.hasOwnProperty(key)){
                    result.push({
                        label: key.label,
                        prop: mapping[key]
                    });
                }
            }
            return result
        },
        transformObjectToLabelPropArray(obj) {
            const result = [];
            const mapping = {
                '名次': 'rank',
                '单位': 'company',
                '选手': 'username',
                '搭档': 'partnerName',                
                '胜轮次': 'winNum',
                '级差总分': 'totalRank',
                '积分': 'score',
                '升级数': 'number',
                '对手总分': 'totalPlayers',
                '对手总级差分': 'totalMinusPlayers',
                '搭档总分': 'partnerScore',
                '搭档总级差分': 'partnerRank'
            };        
            for (let key in obj) {
                if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
                    result.push({
                        label: key,
                        prop: mapping[key]
                    });
                }
            }        
            return result;
        },
        // 导出表格
        handleExport(){
            this.$help.ExportFormData(this.exportData, this.pubTitle)
        },
    },
}
</script>
<style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 16px;
    color: #000;
}
.custom-table .el-table__cell{
    font-size: 20px;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .el-table .cell{
    font-size: 20px;
}
.custom-table >>> .el-input{
    font-size: 20px;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
</style>


// WEBPACK FOOTER //
// src/views/playerScore/playerScore.vue